// src/pages/merchandise.js
import React from 'react';
import { assets } from '../assets/asset_importer';

const Merch = () => {
  
  const patch = assets.images.patches;

  return(
  <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Merch archive</h1>
          <p>Below are all of the patches Integralis has created over the years.</p>
        </div>
      </section>

      <section className='content-section'>
        <div className='container'>
          <div className='mt-2'>
            <h2>General patches</h2>
            <div className='board-grid'>
              <div className="board-member">
                <img src={patch.csolive} alt="CS Olive" className="patch-photo" />
                <h3>CS Olive patch</h3>
              </div>
              
              <div className="board-member">
                <img src={patch.textolive} alt="Text Olive" className="patch-photo" />
                <h3>Text art olive patch</h3>
                
              </div>
              <div className="board-member">
                <img src={patch.weball} alt="Fuck it we ball" className="patch-photo" />
                <h3>Fuck it we ball patch</h3>
                
              </div>
              <div className="board-member">
                <img src={patch.mrworldwide} alt="Mr Worldwide" className="patch-photo" />
                <h3>Mr Worldwide patch</h3>
                
              </div>
              <div className="board-member">
                <img src={patch.intelogo} alt="Integralis logo" className="patch-photo" />
                <h3>Integralis logo patch</h3>
                
              </div>
              <div className="board-member">
                <img src={patch.sisu} alt="Sisu patch" className="patch-photo" />
                <h3>Sisu credit patch</h3>
                
              </div>
              
            </div>
            
          </div>

          <div className='mt-2'>
            <h2>Unique patches</h2>
            <div className='board-grid'>
              <div className="board-member">
                <img src={patch.springsitsit22} alt="Spring break sitsit 2022 patch" className="patch-photo" />
                <h3>Spring break sitsit 2022 patch</h3>
                <p>handed out on 15.5.2022</p>
              </div>
              
              <div className="board-member">
                <img src={patch.fresher23} alt="Freshers 2023 patch" className="patch-photo" />
                <h3>Freshers 2023 patch</h3>
                <p>Handed out to freshers in 2023</p>
              </div>
              <div className="board-member">
                <img src={patch.freshersitsit25} alt="Fresher sitsit 2025 patch" className="patch-photo" />
                <h3>Fresher sitsit 2025 patch</h3>
                <p>Handed out 20.9.2025</p>
              </div>
              <div className="board-member">
                <img src={patch.halloween25} alt="Halloween party 2025 patch" className="patch-photo" />
                <h3>Halloween party 2025 patch</h3>
                <p>handed out on 31.10.2025</p>
              </div>
              <div className="board-member">
                <img src={patch.vujut25} alt="Vujut 2025 patch" className="patch-photo" />
                <h3>Integralis Vujut (6th year anniversary) patch</h3>
                <p>Handed out on 21.11.2025</p>
              </div>
              <div className="board-member">
                <img src={patch.vappu25} alt="Vappu 2025 patch" className="patch-photo" />
                <h3>Vappu 2025 patch</h3>
                <p>handed out during May 2025</p>
              </div>
              <div className="board-member">
                <img src={patch.vappu26} alt="Vappu 2026 patch" className="patch-photo" />
                <h3>Vappu 2026 patch</h3>
                <p>handed out during May 2026</p>
              </div>
              <div className="board-member">
                <img src={patch.fresherventure} alt="Fresher adventure patch" className="patch-photo" />
                <h3>Fresher adventure patch</h3>
                <p>handed out during fresher adventure</p>
              </div>
            </div>
            
          </div>


          <div className='mt-2'>
            <h2>ISS Sitsit in cooperation with Meridiaani</h2>
            <div className='board-grid'>
              <div className="board-member">
                <img src={patch.iss1} alt="ISS Mission 1 patch" className="patch-photo" />
                <h3>ISS Sitsit Mission 1 patch</h3>
                <p>handed out on 20.5.2023</p>
              </div>
              
              <div className="board-member">
                <img src={patch.iss2} alt="ISS Mission 2 patch" className="patch-photo" />
                <h3>ISS Sitsit Mission 2 patch</h3>
                <p>Handed out on 24.3.2024</p>
              </div>
              <div className="board-member">
                <img src={patch.iss3} alt="ISS Mission 3 patch" className="patch-photo" />
                <h3>ISS Sitsit Mission 3 patch</h3>
                <p>handed out on 29.3.2025</p>
              </div>
              <div className="board-member">
                <img src={patch.iss4} alt="ISS Mission 4 patch" className="patch-photo" />
                <h3>ISS Sitsit Mission 4 patch</h3>
                <p>handed out on 8.3.2026</p>
              </div>
              
              
            </div>
            
          </div>
        </div>
      </section>
      </div>
      
  
  );
};

export default Merch;